import { GetHouseSplitMapRepository } from "./interfaces/GetHouseSplitMapRepository";
import { GetHouseSplitMapPresentation } from "./interfaces/GetHouseSplitMapPresentation";
import { SearchRepository } from "../SearchHouses/SearchHousesWithDates/interfaces/SearchHousesWithDatesRepository";

import { Search } from "../../domain";
import { PRICES, formatReplicas } from "../../domain/helpers";

import type { SearchType } from "../../../../services/algolia";
import type {
  ObjectType,
  SearchHouse,
  SupportedCurrencies,
} from "../../../../types";

export default class GetHouseSplitMapUseCase extends Search {
  constructor(private repository: GetHouseSplitMapRepository) {
    super();
  }

  async execute(
    presenter: GetHouseSplitMapPresentation,
    {
      replica = "recommended",
      mode = "client",
      objectID,
      period,
      prices = [PRICES.MIN_PRICE_CHOICE, PRICES.MAX_PRICE_CHOICE],
    }: ObjectType,
    deviceMode: "mobile" | "web",
    currency: SupportedCurrencies | null,
    algoliaIds: SearchType
  ) {
    try {
      const { getHousePeriods, algolia } = this.repository;
      const repository = {
        getHousePeriods,
        algolia: algolia(algoliaIds),
      } as SearchRepository;

      if (period) {
        this.setCurrency(currency || undefined);

        await this.fetchHousePeriodsResponseSplitMap({
          deviceMode,
          currency: this.currency,
          houseIds: [objectID],
          maxBudget: prices[1] || PRICES.MAX_PRICE_CHOICE,
          minBudget: prices[0] || PRICES.MIN_PRICE_CHOICE,
          page: 0,
          period,
          repository,
          sortBy: replica,
        });
      }

      if (
        this.housesStorage.find(
          (h) =>
            h.id === Number(objectID) &&
            h.startAt === period?.startDate &&
            h.endAt === period?.endDate
        )
      )
        return;

      const indexValue = formatReplicas(replica, mode);

      const res = await repository.algolia.getObject<SearchHouse>(
        indexValue,
        objectID
      );

      if (res) {
        if (period) {
          this.housesStorage = [...this.getNewHits([res])];
        } else {
          this.housesStorage = [res];
        }

        presenter.displayHousesStorage(this.housesStorage);
      }
    } catch (err) {
      console.error("GetHouseSplitMapUseCase", err);
    }
  }
}
